import moment from "moment/moment";

export default  {
    methods: {
        processEquipment(payload,equipmentName){
            if(payload.filters.equipment_name) {
                if (payload.pipeline && payload.pipeline.length > 0) {
                    for (let stage of payload.pipeline) {
                        if (stage.type === "filter") {
                            stage.filter_by = stage.filter_by.replace(payload.filters.equipment_name + " - ", equipmentName + " - ")
                        } else if (stage.formula && stage.formula !== "") {
                            stage.formula = stage.formula.replaceAll(payload.filters.equipment_name + " - ", equipmentName + " - ")
                        } else if (stage.type === "insert_series") {
                            stage.name = stage.name.replace(payload.filters.equipment_name + " - ", equipmentName + " - ")
                            if (stage.filters && stage.filters.equipment_name === payload.filters.equipment_name) {
                                stage.filters.equipment_name = equipmentName
                            }
                        }
                    }
                }
                payload.filters.equipment_name = equipmentName
            }
        },
        processDateRange(payload,dateRange){
            if(payload.useCustomRange){
                if (payload.useCustomRelativeRange){
                    let relRange=payload.customRelativeRange&&payload.customRelativeRange!=="" ? payload.customRelativeRange : "30 days"
                    let newRange=null
                    let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
                    let baseDate=moment()
                    if(maxDate){
                        baseDate=moment(maxDate)
                    }
                    let startDate=baseDate.clone().subtract(30, "days")
                    if(relRange==="current week"){
                        startDate=baseDate.clone().startOf("week")
                    } else if(relRange==="current month"){
                        startDate=baseDate.clone().startOf("month")
                    } else if(relRange==="today"){
                        startDate=baseDate.clone().startOf("day")
                    } else if(relRange==="current year"){
                        startDate=baseDate.clone().startOf("year")
                    } else if(relRange==="last week"){
                        baseDate=baseDate.subtract(1,"week").endOf("week")
                        startDate=baseDate.clone().startOf("week")
                    }else if(relRange==="last month"){
                        baseDate=baseDate.subtract(1,"month").endOf("month")
                        startDate=baseDate.clone().startOf("month")
                    }else if(relRange==="yesterday"){
                        baseDate=baseDate.subtract(1,"day").endOf("day")
                        startDate=baseDate.clone().startOf("day")
                    }else if(relRange==="last year"){
                        baseDate=baseDate.subtract(1,"year").endOf("year")
                        startDate=baseDate.clone().startOf("year")
                    }
                    if(relRange==="yesterday"||relRange==="today"){
                        newRange={start:startDate.format('YYYY-MM-DD HH:mm:ss'),end:baseDate.format('YYYY-MM-DD HH:mm:ss')}
                    } else {
                        newRange={start:startDate.format('YYYY-MM-DD'),end:baseDate.format('YYYY-MM-DD')}
                    }
                    payload.date_range=[newRange.start,newRange.end.length<12 ? newRange.end+" 23:59:59": newRange.end]

                } else if (payload.customRange){
                    if (payload.customRangeStartOnly&&dateRange&&dateRange.end){
                        payload.date_range=[payload.customRange.start,dateRange.end.length<12 ? dateRange.end+" 23:59:59": dateRange.end]
                    } else {
                        payload.date_range=[payload.customRange.start,payload.customRange.end.length<12 ? payload.customRange.end+" 23:59:59": payload.customRange.end]
                    }
                }
            } else if(dateRange){
                if(payload.offsetRange&&payload.offsetType){
                    if (payload.offsetRangeStartOnly){
                        if ((payload.offsetType==="year"||payload.offsetType==="years")&&payload.offsetPreciseYear){
                            payload.date_range=[
                                moment(dateRange.start).set('year', payload.offsetPreciseYear).format('YYYY-MM-DD'),
                                dateRange.end.length<12 ? dateRange.end+" 23:59:59": dateRange.end]
                        } else {
                            payload.date_range=[
                                moment(dateRange.start).subtract(payload.offsetAmount, payload.offsetType).format('YYYY-MM-DD'),
                                dateRange.end.length<12 ? dateRange.end+" 23:59:59": dateRange.end]
                        }
                    } else {
                        if ((payload.offsetType==="year"||payload.offsetType==="years")&&payload.offsetPreciseYear){
                            payload.date_range=[
                                moment(dateRange.start).set('year', payload.offsetPreciseYear).format('YYYY-MM-DD'),
                                moment(dateRange.end).set('year', payload.offsetPreciseYear).format('YYYY-MM-DD')+" 23:59:59"]
                        } else {
                            payload.date_range=[
                                moment(dateRange.start).subtract(payload.offsetAmount, payload.offsetType).format('YYYY-MM-DD'),
                                moment(dateRange.end).subtract(payload.offsetAmount, payload.offsetType).format('YYYY-MM-DD')+" 23:59:59"]
                        }
                    }
                } else {
                    payload.date_range=[dateRange.start,dateRange.end.length<12 ? dateRange.end+" 23:59:59": dateRange.end]
                }
            }
        },
    }
};